import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../context/authContext";
import { LoadIcon } from "../../icons/LoadIcon/LoadIcon";
import "./Layout.scss";
// import EngineeringIcon from "@mui/icons-material/Engineering";
// import { CalendarToday } from "@mui/icons-material";
import { ButtonGroup, IconButton } from "@mui/material";
// import WatchLaterIcon from "@mui/icons-material/WatchLater";
function Layout() {
  const { isLoading } = useContext(AuthContext);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div className="wrapper">
      <header className="top-header align-center">
        <ButtonGroup className="top-btn-group">
          <button
            className={`top-btn${pathname === "/" ? " active" : ""}`}
            type="button"
            onClick={() => navigate("/")}
          >
            Board
          </button>
          <button
            className={`top-btn${pathname === "/calendar" ? " active" : ""}`}
            type="button"
            onClick={() => navigate("/calendar")}
          >
            Schedule
          </button>
          {/*<Link to="/">*/}
          {/*  <IconButton title="Board">*/}
          {/*    <EngineeringIcon fontSize="large" />*/}
          {/*  </IconButton>*/}
          {/*</Link>*/}
          {/*<Link to="/calendar">*/}
          {/*  <IconButton title="Calendar">*/}
          {/*    <CalendarToday fontSize="large" />*/}
          {/*  </IconButton>*/}
          {/*</Link>*/}
          {/*<Link to="/working-intervals">*/}
          {/*  <IconButton title="Work intervals">*/}
          {/*    <WatchLaterIcon fontSize="large" />*/}
          {/*  </IconButton>*/}
          {/*</Link>*/}
        </ButtonGroup>
      </header>
      {isLoading ? <LoadIcon /> : <Outlet />}
    </div>
  );
}

export default Layout;
